// Comprehensive grocery items database for autocomplete suggestions
export const groceryDatabase = [
  // Produce - Fruits
  "apples", "apple", "bananas", "banana", "oranges", "orange", "grapes", "grape",
  "strawberries", "strawberry", "blueberries", "blueberry", "raspberries", "raspberry",
  "blackberries", "blackberry", "mangoes", "mango", "pineapple", "kiwi", "kiwis",
  "peaches", "peach", "pears", "pear", "plums", "plum", "cherries", "cherry",
  "watermelon", "cantaloupe", "honeydew", "lemons", "lemon", "limes", "lime",
  "grapefruit", "avocados", "avocado", "berries", "melons", "coconut",
  
  // Produce - Vegetables
  "carrots", "carrot", "broccoli", "spinach", "lettuce", "tomatoes", "tomato",
  "cucumbers", "cucumber", "bell peppers", "peppers", "red peppers", "green peppers",
  "onions", "onion", "garlic", "potatoes", "potato", "sweet potatoes", "sweet potato",
  "celery", "corn", "peas", "green beans", "asparagus", "zucchini", "squash",
  "cabbage", "kale", "brussels sprouts", "cauliflower", "mushrooms", "mushroom",
  "beets", "radish", "eggplant", "artichoke", "leeks", "parsnips", "turnips",
  
  // Meat & Seafood
  "chicken", "chicken breast", "chicken thighs", "beef", "ground beef", "steak",
  "pork", "pork chops", "bacon", "sausage", "sausages", "ham", "turkey",
  "ground turkey", "lamb", "hot dogs", "deli meat", "lunch meat",
  "salmon", "tuna", "shrimp", "crab", "fish", "cod", "tilapia", "lobster",
  "scallops", "mussels", "clams", "sardines", "mackerel", "halibut",
  
  // Dairy & Eggs
  "milk", "whole milk", "2% milk", "skim milk", "almond milk", "soy milk", "oat milk",
  "cheese", "cheddar cheese", "mozzarella", "parmesan", "swiss cheese", "cream cheese",
  "feta cheese", "goat cheese", "string cheese", "yogurt", "greek yogurt",
  "butter", "eggs", "egg whites", "heavy cream", "sour cream", "cottage cheese",
  
  // Pantry
  "rice", "brown rice", "white rice", "pasta", "spaghetti", "penne", "macaroni",
  "flour", "sugar", "brown sugar", "salt", "pepper", "olive oil", "vegetable oil",
  "coconut oil", "vinegar", "balsamic vinegar", "baking soda", "baking powder",
  "vanilla extract", "oats", "quinoa", "cereal", "granola",
  
  // Nuts & Legumes
  "almonds", "walnuts", "cashews", "peanuts", "peanut butter", "almond butter",
  "beans", "black beans", "kidney beans", "chickpeas", "lentils", "pinto beans",
  
  // Canned Goods
  "canned tomatoes", "tomato sauce", "pasta sauce", "marinara sauce", "salsa",
  "canned beans", "canned corn", "chicken broth", "vegetable broth", "soup",
  "tuna cans", "coconut milk", "applesauce",
  
  // Condiments & Sauces
  "ketchup", "mustard", "mayonnaise", "ranch dressing", "italian dressing",
  "soy sauce", "hot sauce", "bbq sauce", "worcestershire sauce", "honey",
  "maple syrup", "jam", "jelly", "pickles", "olives",
  
  // Beverages
  "water", "bottled water", "sparkling water", "orange juice", "apple juice",
  "coffee", "tea", "green tea", "soda", "cola", "sprite", "energy drinks",
  "sports drinks", "wine", "beer", "kombucha",
  
  // Frozen
  "ice cream", "frozen vegetables", "frozen fruit", "frozen pizza", "frozen meals",
  "frozen berries", "ice", "popsicles", "frozen chicken", "frozen fish",
  
  // Bakery
  "bread", "white bread", "wheat bread", "whole grain bread", "whole wheat bread",
  "sourdough", "sourdough bread", "rye bread", "multigrain bread", "sandwich bread",
  "bagels", "english muffins", "muffins", "croissants", "donuts", "danish", "cake",
  "cupcakes", "cookies", "pastry", "pastries", "rolls", "dinner rolls", 
  "hamburger buns", "hot dog buns", "buns", "kaiser rolls", "baguette",
  "pita bread", "naan", "tortillas", "wraps", "flatbread", "brioche", 
  "challah", "pumpernickel", "focaccia", "ciabatta",
  
  // Snacks
  "chips", "potato chips", "tortilla chips", "pretzels", "popcorn", "crackers",
  "granola bars", "protein bars", "candy", "chocolate", "nuts", "trail mix",
  "dried fruit", "beef jerky", "rice cakes",
  
  // Spices & Herbs
  "basil", "oregano", "thyme", "rosemary", "paprika", "cumin", "cinnamon",
  "garlic powder", "onion powder", "chili powder", "black pepper", "sea salt",
  
  // Cleaning & Household (common grocery store items)
  "paper towels", "toilet paper", "dish soap", "laundry detergent", "trash bags",

  // Popular Brands - Beverages
  "Faygo", "Coca Cola", "Pepsi", "Dr Pepper", "Mountain Dew", "Sprite", "Fanta",
  "Gatorade", "Powerade", "Red Bull", "Monster", "Celsius", "Prime",
  "Snapple", "Arizona Tea", "Tropicana", "Minute Maid", "Simply Orange",
  "Ocean Spray", "Capri Sun", "Crystal Light", "Starbucks", "Folgers",
  "LaCroix", "Perrier", "Dasani", "Fiji Water", "Oatly", "Silk",
  "Almond Breeze", "Fairlife", "Nesquik", "Vernors", "Sunkist",

  // Popular Brands - Cereal & Breakfast
  "Cheerios", "Honey Nut Cheerios", "Frosted Flakes", "Froot Loops",
  "Lucky Charms", "Cocoa Puffs", "Cinnamon Toast Crunch", "Cap'n Crunch",
  "Raisin Bran", "Special K", "Rice Krispies", "Honey Bunches of Oats",
  "Quaker Oats", "Pop Tarts", "Eggo Waffles", "Kodiak Cakes",

  // Popular Brands - Snacks
  "Doritos", "Cheetos", "Fritos", "Lay's", "Ruffles", "Pringles",
  "Tostitos", "Sun Chips", "Oreos", "Chips Ahoy", "Goldfish",
  "Cheez-It", "Wheat Thins", "Ritz", "Snickers", "Kit Kat",
  "Skittles", "Kind Bar", "Takis", "Skinny Pop", "Smartfood",

  // Popular Brands - Pet Food
  "Nine Lives", "Meow Mix", "Fancy Feast", "Purina", "Iams", "Pedigree",
  "Blue Buffalo", "Milk-Bone", "Temptations", "Greenies",

  // Popular Brands - Dairy
  "Chobani", "Yoplait", "Oikos", "Sargento", "Tillamook",
  "Kerrygold", "Land O Lakes", "Cool Whip",

  // Popular Brands - Frozen
  "Hot Pockets", "Stouffer's", "Lean Cuisine", "DiGiorno",
  "Red Baron", "Totino's", "Ben & Jerry's", "Talenti", "Breyers",
  "Birds Eye", "Ore-Ida", "Uncrustables",

  // Popular Brands - Meat
  "Tyson", "Perdue", "Oscar Mayer", "Boar's Head", "Hillshire Farm",
  "Johnsonville", "Ball Park", "Hebrew National", "Hormel", "Spam",

  // Popular Brands - Bakery
  "Pepperidge Farm", "Sara Lee", "Dave's Killer Bread", "Nature's Own",
  "Wonder Bread", "Thomas' English Muffins", "Little Debbie", "Hostess",

  // Popular Brands - Pantry
  "Heinz", "Hellmann's", "Jif", "Skippy", "Nutella", "Smucker's",
  "Campbell's", "Progresso", "Barilla", "Prego", "Ragu",
  "Old El Paso", "Goya", "McCormick",

  // Popular Brands - Household
  "Tide", "Gain", "Clorox", "Lysol", "Dawn", "Bounty", "Charmin",
  "Swiffer", "Glad", "Hefty", "Ziploc", "Febreze",

  // Popular Brands - Baby
  "Gerber", "Similac", "Enfamil", "Pampers", "Huggies"
];

// Function to get suggestions based on input
export const getSuggestions = (input, maxSuggestions = 5) => {
  if (!input || input.length < 2) return [];
  
  const searchTerm = input.toLowerCase().trim();
  
  // Exact matches first, then starts with, then contains
  const exactMatches = groceryDatabase.filter(item => 
    item.toLowerCase() === searchTerm
  );
  
  const startsWithMatches = groceryDatabase.filter(item => 
    item.toLowerCase().startsWith(searchTerm) && !exactMatches.includes(item)
  );
  
  const containsMatches = groceryDatabase.filter(item => 
    item.toLowerCase().includes(searchTerm) && 
    !exactMatches.includes(item) && 
    !startsWithMatches.includes(item)
  );
  
  return [...exactMatches, ...startsWithMatches, ...containsMatches]
    .slice(0, maxSuggestions);
};

// Function to get spelling suggestions for misspelled words
export const getSpellingSuggestions = (input) => {
  if (!input || input.length < 3) return [];
  
  const searchTerm = input.toLowerCase().trim();
  
  // Simple fuzzy matching based on edit distance
  const suggestions = groceryDatabase.filter(item => {
    const itemLower = item.toLowerCase();
    
    // Check for transposed characters
    if (Math.abs(itemLower.length - searchTerm.length) <= 2) {
      let differences = 0;
      const minLength = Math.min(itemLower.length, searchTerm.length);
      
      for (let i = 0; i < minLength; i++) {
        if (itemLower[i] !== searchTerm[i]) {
          differences++;
        }
      }
      
      // Allow 1-2 character differences for spelling suggestions
      return differences <= 2;
    }
    
    return false;
  });
  
  return suggestions.slice(0, 3);
};